const styles = {
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  defaultButton: {
    color: 'text.primaryDark',
  },
  progress: {
    color: '#fff',
  },
  primaryButton: {
    maxWidth: '160px',
    width: '100%',
  },
}

export default styles
